import { Icon } from "./Icon.js";
import { fmt } from "../lib/money.js";
import { monthsLabel, monthsToReach } from "../lib/projection.js";
import type { KidBundle } from "../api/me.js";

export interface GoalCardProps {
  goal: KidBundle["goals"][number];
  kid: KidBundle["user"];
  account: KidBundle["account"];
  onClick?: () => void;
}

export function GoalCard({ goal, kid, account, onClick }: GoalCardProps) {
  const pct = Math.min(100, (goal.savedCents / goal.targetCents) * 100);
  const monthlyIncome = account.allowanceCents + account.otherIncomeCents;
  const monthly =
    goal.allocType === "$" ? goal.allocValue : (monthlyIncome * goal.allocValue) / 100;
  const m = monthsToReach(goal, monthly);
  const color = kid.color ?? "var(--brand)";
  const colorSoft = kid.colorSoft ?? "var(--brand-soft)";

  return (
    <div className="goal-card card" onClick={onClick} style={{ padding: 22 }}>
      <div className="row" style={{ marginBottom: 16 }}>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: colorSoft,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color,
          }}
        >
          <Icon name={goal.icon} size={28} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 500, fontSize: 17 }}>{goal.title}</div>
          <div className="soft" style={{ fontSize: 13 }}>
            {monthsLabel(m)} at this pace
          </div>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "baseline", gap: 8, marginBottom: 10 }}>
        <div className="money money-md">{fmt(goal.savedCents)}</div>
        <div className="soft" style={{ fontSize: 14 }}>
          of {fmt(goal.targetCents, { showCents: false })}
        </div>
      </div>

      <div className="progress" style={{ marginBottom: 12 }}>
        <div className="progress-fill" style={{ width: `${pct}%`, background: color }} />
      </div>

      <div className="row-between">
        <div className="chip" style={{ background: colorSoft, color }}>
          {goal.allocType === "$"
            ? `${fmt(goal.allocValue, { showCents: false })}/mo`
            : `${goal.allocValue}% of income`}
        </div>
        <div className="soft" style={{ fontSize: 13 }}>
          {pct.toFixed(0)}% there
        </div>
      </div>
    </div>
  );
}
